// extracted by mini-css-extract-plugin
module.exports = {"FormTitle":"Basics_FormTitle_t4Wvi","formLayout":"Basics_formLayout_1XrsI","box":"Basics_box_3nk8y"};